<div class="sp">
  <!-- Шапка поставки -->
  <header class="sp-head">
    <a class="sp-back" routerLink="/cargo-owner/dashboard/supplies">
      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 5l-5 5 5 5"/></svg>
      {{ t('coNav.supplies', 'Мои поставки') }}
    </a>
    <div class="sp-head__row">
      <h1 *ngIf="!byDeal">{{ t('coSupply.title', 'Поставка') }} № {{ id }}</h1>
      <h1 *ngIf="byDeal">{{ t('coSupply.title', 'Поставка') }} {{ dealId | docNo:'D':deal?.createdAt }}</h1>
      <span class="pp-badge pp-badge--blue" *ngIf="calculation">{{ statusText }}</span>
      <span class="pp-badge pp-badge--blue" *ngIf="byDeal && deal">{{ dealStage }}</span>
    </div>
    <p class="sp-head__sub" *ngIf="calculation">
      <span *ngIf="productsSummary">{{ productsSummary }}</span>
      <span *ngIf="calculation.invoiceData?.invoiceNumber">{{ t('common.supplies.invoice', 'Инвойс') }} {{ calculation.invoiceData?.invoiceNumber }}</span>
      <span *ngIf="calculation.createdAt">{{ calculation.createdAt | date:'dd.MM.yyyy' }}</span>
    </p>
    <p class="sp-head__sub" *ngIf="byDeal && deal">
      <span *ngIf="dealCargo">{{ dealCargo }}</span>
      <span *ngIf="dealRoute">{{ dealRoute }}</span>
      <span *ngIf="deal.freightForwarder?.companyName">{{ deal.freightForwarder.companyName }}</span>
      <span>{{ deal.createdAt | date:'dd.MM.yyyy' }}</span>
    </p>
  </header>

  <!-- Вкладки -->
  <nav class="sp-tabs" role="tablist">
    <a *ngFor="let x of tabs; let i = index" role="tab" class="sp-tab" [class.is-active]="tab === x.id" [attr.aria-selected]="tab === x.id"
       [routerLink]="base.concat(x.id)">
      <span class="sp-tab__n">{{ i + 1 }}</span>{{ t(x.key, x.fallback) }}
    </a>
  </nav>

  <div *ngIf="loading" class="pp-loading">{{ t('common.loading', 'Загрузка...') }}</div>
  <div *ngIf="error" class="pp-error">{{ error }}</div>

  <ng-container *ngIf="calculation || deal">
    <!-- 1. Предварительный расчёт — справка: прогноз, товары, документы; подробности — в кабинете расчёта -->
    <section *ngIf="visited.has('calculation')" [hidden]="tab !== 'calculation'" class="sp-summary">
      <ng-container *ngIf="calculation as c; else noCalc">
        <div class="pp-card sp-card">
          <div class="sp-card__head">
            <div>
              <h2>{{ t('coSupply.forecast', 'Прогноз по расчёту') }}</h2>
              <p class="sp-card__note">{{ t('coSupply.forecastNote', 'Оценка до поставки') }}<ng-container *ngIf="c.createdAt"> · {{ c.createdAt | date:'dd.MM.yyyy' }}</ng-container></p>
            </div>
            <a class="pp-btn pp-btn--ghost" [routerLink]="['/calculations', id, 'overview']">{{ t('coSupply.openCalc', 'Открыть расчёт полностью') }} ›</a>
          </div>
          <dl class="sp-facts sp-facts--4">
            <div><dt>{{ t('coSupply.goodsCost', 'Стоимость товара') }}</dt><dd>{{ money(c.totalProductCostKzt) }}</dd></div>
            <div><dt>{{ t('coDash.customsPayments', 'Таможенные платежи') }}</dt><dd>{{ money(c.totalCustomsPayments) }}</dd></div>
            <div>
              <dt>{{ t('coSupply.deliveryForecast', 'Доставка (прогноз)') }}</dt>
              <dd *ngIf="sellerDelivers" class="sp-muted">{{ t('coSupply.inGoodsPrice', 'в цене товара') }}</dd>
              <ng-container *ngIf="!sellerDelivers">
                <dd *ngIf="forecastDelivery as fd; else noForecast">{{ money(fd.amount, fd.currency) }}</dd>
                <ng-template #noForecast><dd class="sp-muted">{{ t('coSupply.notCalculated', 'не рассчитана') }}</dd></ng-template>
                <small *ngIf="forecastDelivery?.currency !== 'KZT' && forecastDeliveryKzt">≈ {{ money(forecastDeliveryKzt) }}</small>
              </ng-container>
            </div>
            <div class="sp-total"><dt>{{ t('coSupply.forecastTotal', 'Ориентировочно итого') }}</dt><dd>≈ {{ money(forecastTotalKzt) }}</dd></div>
          </dl>
        </div>

        <div class="pp-card sp-card" *ngIf="products.length">
          <h2>{{ t('coSupply.goods', 'Товары') }} <span class="sp-count">{{ products.length }}</span></h2>
          <div class="pp-table-wrap">
            <table class="pp-table sp-table">
              <thead>
                <tr>
                  <th>{{ t('coSupply.goodsName', 'Наименование') }}</th>
                  <th>{{ t('coSupply.tnved', 'Код ТН ВЭД') }}</th>
                  <th>{{ t('coSupply.goodsCost', 'Стоимость товара') }}</th>
                  <th>{{ t('coDash.customsPayments', 'Таможенные платежи') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of products">
                  <td class="sp-name" [attr.title]="p.nameForBroker || p.nameOriginal">{{ p.nameForBroker || p.nameOriginal }}</td>
                  <td class="sp-code">{{ p.tnvedCodeForBroker || p.tnvedCodeOriginal || '—' }}</td>
                  <td class="pp-num pp-nowrap">{{ money(p.productCostKzt) }}</td>
                  <td class="pp-num pp-nowrap">{{ money(p.totalCustomsPayments) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pp-card sp-card">
          <h2>{{ t('coSupply.permits', 'Разрешительные документы') }}</h2>
          <p class="sp-card__note" *ngIf="permits === null">
            {{ t('coSupply.permitsNotChecked', 'Проверка документов по этому расчёту не выполнялась.') }}
            <a [routerLink]="['/calculations', id, 'permits']">{{ t('coSupply.permitsRun', 'Проверить в расчёте') }} ›</a>
          </p>
          <ul class="sp-permits" *ngIf="permits as list">
            <li *ngFor="let x of list">
              <span class="sp-code">{{ x.code }}</span>
              <span *ngIf="x.docs.length; else noDocsNeeded">{{ x.docs.join(' · ') }}</span>
              <ng-template #noDocsNeeded><span class="sp-ok">{{ t('coSupply.permitsNone', 'Не требуются') }}</span></ng-template>
            </li>
          </ul>
        </div>
      </ng-container>

      <!-- Поставка по сделке без расчёта -->
      <ng-template #noCalc>
        <div class="pp-card sp-card sp-soon">
          <span class="sp-soon__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 12h2M14 12h2M8 16h2M14 16h2"/></svg></span>
          <h2>{{ t('coSupply.noCalcTitle', 'Расчёт не делался') }}</h2>
          <p>{{ t('coSupply.noCalcText', 'Эта перевозка оформлена без предварительного расчёта. Сделайте расчёт, чтобы узнать таможенные платежи и нужные разрешительные документы.') }}</p>
          <a class="pp-btn pp-btn--primary" routerLink="/calculations/new">{{ t('coSupply.makeCalc', 'Сделать расчёт') }}</a>
        </div>
      </ng-template>
    </section>

    <!-- 2. Поставщик (приглашение и документы поставщика — через расчёт) -->
    <section *ngIf="visited.has('supplier')" [hidden]="tab !== 'supplier'" class="pp-card sp-card" [class.sp-soon]="!calculation">
      <app-process-calculation *ngIf="calculation" [embeddedCalculationId]="id" embeddedSection="supply"></app-process-calculation>
      <ng-container *ngIf="!calculation">
        <h2>{{ t('coSupply.tabSupplier', 'Поставщик') }}</h2>
        <p>{{ t('coSupply.supplierNeedsCalc', 'Поставщик подключается к поставке через расчёт: он заполняет инвойс и упаковочный лист. У этой перевозки расчёта нет.') }}</p>
        <a class="pp-btn pp-btn--primary" routerLink="/calculations/new">{{ t('coSupply.makeCalc', 'Сделать расчёт') }}</a>
      </ng-container>
    </section>

    <!-- 3. Перевозка: запрос → ставки → сделка -->
    <section *ngIf="visited.has('transport')" [hidden]="tab !== 'transport'">
      <app-process-calculation *ngIf="calculation" [embeddedCalculationId]="id" embeddedSection="transportation"></app-process-calculation>
      <app-view-deal *ngIf="byDeal" [embeddedDealId]="dealId"></app-view-deal>
    </section>

    <!-- 4. Сертификация -->
    <section *ngIf="visited.has('certification')" [hidden]="tab !== 'certification'" class="pp-card sp-card sp-soon">
      <span class="sp-soon__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg></span>
      <h2>{{ t('coSupply.certTitle', 'Сертификация') }}</h2>
      <p>{{ t('coSupply.certText', 'Здесь появятся заявки на сертификаты и декларации соответствия по этой поставке и их статусы. Какие документы нужны для ваших товаров — уже видно в предварительном расчёте.') }}</p>
      <button type="button" class="pp-btn pp-btn--primary" (click)="open('calculation')">{{ calculation ? t('coSupply.openPermits', 'Разрешительные документы') : t('coSupply.tabCalculation', 'Предварительный расчёт') }}</button>
    </section>

    <!-- 5. Таможенная очистка: статус и все папки документов, которые отдаёт сервер -->
    <section *ngIf="visited.has('customs')" [hidden]="tab !== 'customs'" class="sp-summary">
      <div class="pp-card sp-card sp-customs">
        <h2>{{ t('coSupply.customsTitle', 'Таможенная очистка') }} <span class="pp-badge pp-badge--blue" *ngIf="calculation">{{ statusText }}</span></h2>
        <p class="sp-card__note">{{ t('coSupply.customsText', 'Таможенное оформление ведёт брокер Bilload. Документы для очистки — ниже, по папкам.') }}</p>
        <dl class="sp-facts" *ngIf="calculation as c">
          <div><dt>{{ t('coSupply.customsPayments', 'Таможенные платежи по расчёту') }}</dt><dd>{{ money(c.totalCustomsPayments) }}</dd></div>
          <div><dt>{{ t('coSupply.goodsCost', 'Стоимость товара') }}</dt><dd>{{ money(c.totalProductCostKzt) }}</dd></div>
        </dl>
      </div>

      <!-- Документы — папки сделки по перевозке (загрузка, просмотр, скачивание) -->
      <app-view-deal *ngIf="supplyDealId as did; else noDocs" [embeddedDealId]="did" [documentsOnly]="true"></app-view-deal>
      <ng-template #noDocs>
        <div class="pp-card sp-card sp-soon">
          <h2>{{ t('deal.documents', 'Документы') }}</h2>
          <p>{{ t('coSupply.docsAfterDeal', 'Папки документов появятся, когда будет выбран экспедитор и заключена сделка по перевозке.') }}</p>
          <button type="button" class="pp-btn pp-btn--primary" (click)="open('transport')">{{ t('coSupply.tabTransport', 'Перевозка') }}</button>
        </div>
      </ng-template>
    </section>

    <!-- 6. Сводка по поставке -->
    <section *ngIf="visited.has('summary')" [hidden]="tab !== 'summary'" class="sp-summary">
      <!-- Прогноз из расчёта против факта поставки -->
      <div class="pp-card sp-card">
        <h2>{{ t('coSupply.costs', 'Стоимость поставки') }}</h2>
        <div class="pp-table-wrap">
          <table class="pp-table sp-table sp-vs">
            <thead>
              <tr>
                <th></th>
                <th>{{ t('coSupply.forecastCol', 'Прогноз') }}</th>
                <th>{{ t('coSupply.actualCol', 'Факт') }}</th>
                <th>{{ t('coSupply.diffCol', 'Разница') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ t('coSupply.goodsCost', 'Стоимость товара') }}</td>
                <td class="pp-num pp-nowrap">{{ calculation ? money(calculation.totalProductCostKzt) : '—' }}</td>
                <td class="pp-num pp-nowrap">{{ calculation ? money(calculation.totalProductCostKzt) : '—' }}</td>
                <td class="pp-num sp-muted">—</td>
              </tr>
              <tr>
                <td>{{ t('coDash.customsPayments', 'Таможенные платежи') }}</td>
                <td class="pp-num pp-nowrap">{{ calculation ? money(calculation.totalCustomsPayments) : '—' }}</td>
                <td class="pp-num sp-muted">{{ t('coSupply.afterClearance', 'после очистки') }}</td>
                <td class="pp-num sp-muted">—</td>
              </tr>
              <tr>
                <td>{{ t('coSupply.freight', 'Перевозка') }}</td>
                <td class="pp-num pp-nowrap">{{ !calculation ? '—' : sellerDelivers ? t('coSupply.inGoodsPrice', 'в цене товара') : (forecastDeliveryKzt != null ? '≈ ' + money(forecastDeliveryKzt) : t('coSupply.notCalculated', 'не рассчитана')) }}</td>
                <td class="pp-num pp-nowrap">
                  <ng-container *ngIf="deal?.bid as bid; else noFact">
                    {{ money(bid.price, bid.currencyCode) }}
                    <small *ngIf="bid.currencyCode !== 'KZT' && actualFreightKzt != null">≈ {{ money(actualFreightKzt) }}</small>
                  </ng-container>
                  <ng-template #noFact><span class="sp-muted">{{ t('coSupply.freightNone', 'ставка не выбрана') }}</span></ng-template>
                </td>
                <td class="pp-num pp-nowrap">
                  <ng-container *ngIf="calculation">
                    <span *ngIf="diff(actualFreightKzt, sellerDelivers ? null : forecastDeliveryKzt) as d" [class.sp-up]="d > 0" [class.sp-down]="d < 0">
                      {{ d > 0 ? '+' : '−' }}{{ money(d > 0 ? d : -d) }}
                    </span>
                  </ng-container>
                </td>
              </tr>
              <tr class="sp-vs__total">
                <td>{{ t('coSupply.total', 'Итого') }}</td>
                <td class="pp-num pp-nowrap">{{ calculation ? '≈ ' + money(forecastTotalKzt) : '—' }}</td>
                <td class="pp-num pp-nowrap">{{ money(totalKzt) }}</td>
                <td class="pp-num pp-nowrap">
                  <ng-container *ngIf="calculation">
                    <span *ngIf="diff(totalKzt, forecastTotalKzt) as d" [class.sp-up]="d > 0" [class.sp-down]="d < 0">
                      {{ d > 0 ? '+' : '−' }}{{ money(d > 0 ? d : -d) }}
                    </span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="sp-card__note">
          {{ calculation
            ? t('coSupply.vsNote', 'Прогноз — из предварительного расчёта, факт — по выбранной ставке перевозки. Таможенные платежи станут фактом после очистки.')
            : t('coSupply.vsNoCalc', 'Расчёта по этой перевозке не было — прогноза нет, в сумме только перевозка по выбранной ставке.') }}
        </p>
      </div>

      <div class="pp-card sp-card">
        <h2>{{ t('coSupply.steps', 'Этапы поставки') }}</h2>
        <ol class="sp-steps">
          <li [class.is-done]="calculation" (click)="open('calculation')">
            <span class="sp-steps__mark"></span>
            <b>{{ t('coSupply.tabCalculation', 'Предварительный расчёт') }}</b>
            <span>{{ calculation ? t('coSupply.calcReady', 'Готов') : t('coSupply.noCalcTitle', 'Расчёт не делался') }}</span>
          </li>
          <li [class.is-done]="calculation?.supplierId" (click)="open('supplier')">
            <span class="sp-steps__mark"></span>
            <b>{{ t('coSupply.tabSupplier', 'Поставщик') }}</b>
            <span>{{ calculation?.supplierId ? (t('coSupply.supplierOn', 'Подключён') + ': ' + (calculation?.supplierCompanyName || '#' + calculation?.supplierId)) : t('coSupply.supplierOff', 'Не приглашён') }}</span>
          </li>
          <li [class.is-done]="supplyDealId" [class.is-active]="!supplyDealId && requests.length" (click)="open('transport')">
            <span class="sp-steps__mark"></span>
            <b>{{ t('coSupply.tabTransport', 'Перевозка') }}</b>
            <span *ngIf="supplyDealId as did">{{ did | docNo:'D':deal?.createdAt }} · {{ deal ? dealStage : '…' }}</span>
            <span *ngIf="!supplyDealId && requests.length">{{ t('coSupply.requestSent', 'Запрос отправлен, ждём ставки') }}</span>
            <span *ngIf="!supplyDealId && !requests.length">{{ t('coSupply.requestNone', 'Запрос на перевозку не создан') }}</span>
          </li>
          <li (click)="open('certification')">
            <span class="sp-steps__mark"></span>
            <b>{{ t('coSupply.tabCertification', 'Сертификация') }}</b>
            <span>{{ t('coSupply.soon', 'Скоро') }}</span>
          </li>
          <li class="is-active" (click)="open('customs')">
            <span class="sp-steps__mark"></span>
            <b>{{ t('coSupply.tabCustoms', 'Таможенная очистка') }}</b>
            <span>{{ calculation ? statusText : t('deal.documents', 'Документы') }}</span>
          </li>
        </ol>
      </div>
    </section>
  </ng-container>
</div>
